import RejectedResult from './RejectedResult';
export default RejectedResult;
